import { withPrefix } from 'gatsby-link'

import mt174 from './assets/MT174.png'
import me381 from './assets/ME381.png'
import am550 from './assets/AM550.png'
import mt880 from './assets/MT880.png'

import p2lpc from './assets/P2LPC.png'
import ac750 from './assets/AC750.png'
import sep from './assets/SEP.jpg'

import sonda5 from './assets/Sonda_5.jpg'

import cmModules from './assets/CM-modules.png'

const mt174pdf = withPrefix('MT174_HRV.pdf')
const mx381pdf = withPrefix('Mx381_HRV.pdf')
const mx382pdf = withPrefix('Mx382_HRV.pdf')
const am550pdf = withPrefix('AM550_HRV.pdf')
const mt880mpdf = withPrefix('MT880_M_HRV.pdf')
const p2lpcpdf = withPrefix('P2LPC_HRV.pdf')
const ac750pdf = withPrefix('AC750_HRV.pdf')

export const brojila = [
  {
    title: 'MT174',
    subtitle:
      'Savršena kombinacija visoke funkcionalnosti i ekonomske održivosti',
    text:
      'Višefazni MT174 ima RS komunikacijsko sučelje koje omogućuje automatsko očitavanje brojila i priprema brojilo za korištenje u AMI sustavima. Opsežne funkcije koje onemogućavaju neovlašteno manipuliranje brojilom pružaju maksimalnu sigurnost za mjernih podataka. Visoko kvalitetan proizvodni proces omogućuje brojilu rad u stambenim i malim komercijalnim okruženjima.',
    image: mt174,
    pdfs: [
      {
        link: mt174pdf,
        title: 'MT174.pdf',
      },
    ],
  },
  {
    title: 'Mx38y',
    subtitle:
      'Interoperabilno pametno brojilo s opsežnim funkcionalnim sposobnostima',
    text:
      'Generacija pametnih brojila s IDIS interoperabilnošću pravo je rješenje protiv ulaganja u loša brojila. Mx38y pametno brojilo djeluje kao komunikacijski pristupnik za interakciju i prikupljanje podataka s drugih energetskih uređaja (plin, voda, grijanje) i može se prilagoditi i nadograditi za buduće poslovne modele (putem specifičnih softverskih aplikacija). Suvremene metode šifriranja i provjere autentičnosti jamče maksimalnu sigurnost za vrijedne mjerne podatke.',
    image: me381,
    pdfs: [
      {
        link: mx381pdf,
        title: 'Mx381.pdf',
      },
      {
        link: mx382pdf,
        title: 'Mx382.pdf',
      },
    ],
  },
  {
    title: 'AM550',
    subtitle: 'Modularno brojilo „Spremno za korištenje u pametnoj mreži"',
    text:
      'Pametno brojilo nove generacije s inovativnim platformskim pristupom, omogućuje besprijekornu integraciju funkcija pametnog brojila u pametnu mrežu. Univerzalno, standardizirano, transparentno sučelje za programiranje aplikacija unutar brojila olakšava jednostavnu razmjenu različitih komunikacijskih modula - to daje korisnicima potrebnu fleksibilnost za buduće poslovne modele. PLC komunikacijski moduli su kompatibilni s ranijim verzijama i time omogućuju, na primjer, jednostavno prebacivanje sa G1 na G3 komunikacijsku tehnologiju. Specifične korisničke aplikacije za „Smart Grid“ značajka su nove razine sposobnosti prilagođavanja brojila.',
    image: am550,
    pdfs: [
      {
        link: am550pdf,
        title: 'AM550.pdf',
      },
    ],
    additionalInfo: {
      title: 'Komunikacijski moduli',
      items: [
        {
          title: 'AC150-G3',
          text: 'G3 komunikacijski modul',
        },
        {
          title: 'AC150-A2',
          text: 'Komunikacijski modul s GPRS sučeljem',
        },
        {
          title: 'AC150-A5',
          text: 'Komunikacijski modul s GPRS / LTE sučeljem',
        },
      ],
    },
  },
  {
    title: 'MT880',
    subtitle:
      'Modularno precizno brojilo sa sveobuhvatnim kompletom funkcionalnosti',
    text:
      'Ovaj uređaj, koji je pogodan za velike i srednje velike komercijalne i industrijske aplikacije, u potpunosti obuhvaća zahtjeve tržišta pametne mreže i distribuiranog trenda proizvodnje. Praćenje kvalitete napajanja, bežična SCADA povezivost, modularnost komunikacije i brojni sigurnosni mehanizmi samo su neki od atributa koji jamče da je vaše ulaganje sigurno i dugoročno.',
    image: mt880,
    pdfs: [
      {
        link: mt880mpdf,
        title: 'MT880_M.pdf',
      },
    ],
    additionalInfo: {
      title: 'Komunikacijski moduli',
      items: [
        {
          title: 'CM-v-3',
          text: '2G modem s RS485 komunikacijskim sučeljem',
        },
        {
          title: 'CM-u-3',
          text: '3G modem s RS485 komunikacijskim sučeljem',
        },
        {
          title: 'CM-e-3',
          text: 'Ethernet modem s RS485 komunikacijskim sučeljem',
        },
        {
          title: 'CM-f3e',
          text: 'MODBUS modem preko TCP/IP i RTU',
        },
        {
          title: 'CM-1-3',
          text: 'Komunikacijski modul s CS i RS485 komunikacijskim sučeljima',
        },
      ],
      images: [{ source: cmModules }],
    },
  },
]

export const oprema = [
  {
    title: 'P2LPC',
    subtitle:
      'Koncentrator podataka visoke učinkovitosti za upravljanje zajedničkim PLC brojilima',
    text:
      'Iskraemeco P2LPC podatkovni koncentrator je uređaj koji se dokazao u primjeni i koji omogućuje pouzdanu dvosmjernu komunikaciju s pametnim brojilima putem električnih vodova, upravlja mrežom i osigurava besprijekornu povezanost sa sustavom centra. Njegove napredne značajke čine ga idealnim za korištenje brojila u malim i velikim građevinskim kompleksima.',
    image: p2lpc,
    pdfs: [
      {
        link: p2lpcpdf,
        title: 'P2LPC.pdf',
      },
    ],
  },
  {
    title: 'AC750',
    subtitle:
      'Inovativna platforma s najsuvremenijim modularnim hardverom i softverom',
    text:
      'AC750 G3-PLC gateway / podatkovni koncentrator je ulaganje u budućnost integracije u pametnu mrežu. Ovaj komunikacijski uređaj temelji se na inovativnoj platformi koja povezuje sustav centra/Head-End-System s brojilima električne energije. Optimizira komunikacijski promet na vašoj mreži i učinkovito prenosi mjerne podatke i obavijesti o mreži. AC750 podržava širok raspon komunikacijskih sučelja i protokola, a opremljen je komunikacijskim modulima za zamjenu polja.',
    image: ac750,
    pdfs: [
      {
        link: ac750pdf,
        title: 'AC750.pdf',
      },
    ],
  },
  {
    title: 'Sonda 5',
    text:
      'Sonda 5 s RS232 konektorom (brzina prijenosa do 57600 Bauda), te s USB konektorom (brzina prijenosa do 115200 Bauda). Služe za programiranje i očitanje podataka iz brojila i registratora putem optičkog sučelja sukladno s normom IEC 62056-21.',
    image: sonda5,
  },
]

export const programi = [
  {
    title: 'Programska rješenja',
    subtitle: 'SEP2W sustav',
    text:
      'Na svim razinama potrošnje, prijenosa i generacije energije univerzalni Iskraemeco AMM-sustav (Automated Meter Management) omogućava prikupljanje, pohranjivanje i obradu podataka o protoku električne energije kao i drugih energenata (toplinska energija, plin, voda itd.). Modularna struktura omogućava uporabu različitih mjernih i komunikacijskih naprava. U sustavu su mogući različit komunikacijski putevi (izravno povezivanje preko sučelja RS232, RS485 ili CS te modemske veze DLC, PSTN, ISDN, GSM/GPRS/UMTS/EDGE, ethernet itd.) kao i različiti protokoli (DLMS, IEC 62056-21, IEC 60870-5-102, FTP, NTP, SNMP, SOAP). Za korisnika lako razumljiv sofver omogućava jednostavno zahvatanje i obradu podataka, praćenje događanja kao i upravljanje električnom mrežom.',
    image: sep,
    pdfs: [],
  },
]



// WEBPACK FOOTER //
// ./src/productInfo.js